<template>
  <div class="min-h-screen bg-gray-950 text-gray-100 font-sans selection:bg-purple-500/30">
    <Navigation />
    <main class="container mx-auto px-4 py-8 pb-20 md:pb-8">
      <slot />
    </main>
    <footer class="border-t border-gray-800 mt-12 py-8 text-center text-gray-500 mb-16 md:mb-0">
      <p>Made with 💜 by t-witchy</p>
    </footer>
  </div>
</template>

<script setup>
// Layout for authenticated users
</script>

<style>
/* Global overrides for this layout if strictly necessary */
</style>
